export default "__VITE_ASSET__CXX5tyXL__"